import IconCheckmark from './icon-checkmark.svg'
import IconConcierge from './icon-concierge.svg'
import IconCross from './icon-cross.svg'
import KindestLogoSmall from './kindest-logo-small.svg'

// tsx icons
import IconCalendar from './IconCalendar'
import IconLocation from './IconLocation'
import IconSearch from './IconSearch'
import IconSuccess from './IconSuccess'
import IconFacebook from './IconFacebook'
import IconX from './IconX'
import IconLinkedin from './IconLinkedin'
import IconInstagram from './IconInstagram'
import IconEmail from './IconEmail'
import IconLink from './IconLink'
import IconArrow from './IconArrow'
import IconSettings from './IconSettings'
import IconAllocation from './IconAllocation'
import IconDomain from './IconDomain'
import IconDonateButton from './IconDonateButton'
import IconDonationPage from './IconDonationPage'
import IconEmailCapture from './IconEmailCapture'
import IconCampaignTracking from './IconCampaignTracking'
import IconMember from './IconMember'
import IconMobile from './IconMobile'
import IconPayouts from './IconPayouts'
import IconStar from './IconStar'
import IconTags from './IconTags'
import IconPreview from './IconPreview'
import IconMedia from './IconMedia'
import IconStory from './IconStory'
import IconDonationTiers from './IconDonationTiers'
import IconPerson from './IconPerson'
import IconArrowLeft from './IconArrowLeft'
import IconGoals from './IconGoals'
import IconEmbedded from './IconEmbedded'
import IconEyeOff from './IconEyeOff'
import IconListOptions from './IconListOptions'
import IconFile from './IconFile'
import IconCsv from './IconCsv'
import IconQrCode from './IconQrCode'
import IconEmailOutline from './IconEmailOutline'
import IconTrashcan from './IconTrashcan'
import IconDownload from './IconDownload'
import IconStripe from './IconStripe'
import IconCard from './IconCard'
import IconSend from './IconSend'
import IconStop from './IconStop'
import IconWarning from './IconWarning'

export {
  IconCalendar,
  IconCheckmark,
  IconConcierge,
  IconCross,
  IconLocation,
  KindestLogoSmall,
  IconSearch,
  IconSuccess,
  IconFacebook,
  IconX,
  IconLinkedin,
  IconInstagram,
  IconEmail,
  IconLink,
  IconArrow,
  IconSettings,
  IconAllocation,
  IconDomain,
  IconDonateButton,
  IconDonationPage,
  IconEmailCapture,
  IconCampaignTracking,
  IconMember,
  IconMobile,
  IconPayouts,
  IconStar,
  IconTags,
  IconPreview,
  IconMedia,
  IconStory,
  IconDonationTiers,
  IconPerson,
  IconArrowLeft,
  IconGoals,
  IconEmbedded,
  IconEyeOff,
  IconListOptions,
  IconFile,
  IconCsv,
  IconQrCode,
  IconEmailOutline,
  IconTrashcan,
  IconDownload,
  IconStripe,
  IconCard,
  IconSend,
  IconStop,
  IconWarning,
}
